import React from "react";
import { Box, Typography, Alert } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const FinOpsErrorState = ({ error }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "400px",
        gap: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 48, color: "error.main" }} />
      <Alert severity="error" sx={{ width: "100%", maxWidth: 600 }}>
        <Typography variant="h6" gutterBottom>
          Error Loading Dashboard
        </Typography>
        <Typography variant="body2">
          {error || "An error occurred while fetching FinOps dashboard data. Please try again later."}
        </Typography>
      </Alert>
    </Box>
  );
};

export default FinOpsErrorState;

